import {createEntityAdapter} from '@reduxjs/toolkit'
import {IPaymentType} from '../../types'

export const expenditureTypesAdapter = createEntityAdapter<IPaymentType>()